import { WafCheckContract } from '@terra/shared-contracts-waf-check';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const wafCheckClient = createTerraOrpcClient({
  contract: WafCheckContract,
  serviceName: SERVICE_NAME,
});
